import React from 'react';
import { Box, Typography } from '@mui/material';

// Sirv-hosted item/category images. The CDN bucket is shared across
// tenants; `root` differentiates them (URL-encoded `general.root_category`
// from each tenant's Mongo Config — backroom-server returns it in the
// `image_root` field of the tenants list).

type Props = {
  /** Sirv image id; render a placeholder when missing. */
  id?: string | null;
  /** Tenant's image root prefix (e.g. "The Back Room"). */
  imageRoot: string;
  /** Fallback alt text + placeholder label. */
  title: string;
  /** Pixel size for the square frame. */
  size?: number;
};

const ItemImage: React.FC<Props> = ({ id, imageRoot, title, size = 180 }) => {
  const frame = {
    width: size,
    height: size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f1f5f9',
    borderRadius: 1,
    overflow: 'hidden',
  } as const;

  if (!id) {
    return (
      <Box sx={frame}>
        <Typography
          variant="caption"
          sx={{ color: '#94a3b8', px: 1, textAlign: 'center' }}
        >
          {title}
        </Typography>
      </Box>
    );
  }

  const src = `https://thequeensflorist.sirv.com/${encodeURIComponent(imageRoot)}/${encodeURIComponent(
    id,
  )}.jpg`;

  return (
    <Box sx={frame}>
      <img
        src={src}
        alt={title}
        title={title}
        loading="lazy"
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default ItemImage;
